export default __webpack_public_path__ + "static/media/loyalty.67353e57.svg";